import React from 'react'

const WhyLearnReactNative = () => (
  <section id='why-learn-react-native' className='section'>
    <div className='container'>
      <h1 className='title is-1'>Por que devo aprender React Native?</h1>

      <div className='columns'>
        <div className='column'>
          <i className='fa fa-mobile-alt' />
          <h3 className='subtitle'>Multiplataforma</h3>
          <p>
            Cada plataforma tem suas peculiaridades. Então isso não é problema
            com React Native, já que ele mantém o visual de cada componente
            nativo de cada plataforma. Ou seja, é possível criar um app usando o
            iOS Human User Interface guidelines e também usando Material Design
            para Android. Tudo isso em um único projeto!
          </p>
        </div>
        <div className='column'>
          <i className='fa fa-file-code' />
          <h3 className='subtitle'>Código Nativo</h3>
          <p>
            Diferente de frameworks híbridos que utilizam apenas HTML5, CSS e
            JS, o React Native possui uma integração com código nativo em cada
            plataforma. Ou seja, o componente Image no React Native, utiliza o
            UIImageView no iOS e o ImageView no Android. Por isso o ganho de
            performance é grande, pois utiliza realmente código nativo por trás
            das cenas.
          </p>
        </div>
        <div className='column'>
          <i className='fa fa-share-alt' />
          <h3 className='subtitle'>Compartilhamento de Código</h3>
          <p>
            O React Native utiliza o conceito de componentização. Ou seja, você
            pode criar componentes para cada bloco de UI do seu aplicativo,
            podendo reutilizá-los dentro do próprio projeto ou até mesmo para
            projetos futuros. Todo seu esforço pode ser reaproveitado!
          </p>
        </div>
      </div>
      <div className='columns'>
        <div className='column'>
          <i className='fa fa-bolt' />
          <h3 className='subtitle'>Produtividade</h3>
          <p>
            Além do compartilhamento de código, que torna o desenvolvimento mais
            produtivo, o React Native traz os conceitos da web, como Hot
            Reloading. Ao invés de ficar recompilando toda hora para visualizar
            como o aplicativo está ficando, você visualiza em tempo real as
            modificações enquanto desenvolve seu app.
          </p>
        </div>
        <div className='column'>
          <i className='fa fa-users' />
          <h3 className='subtitle'>Comunidade fortemente Ativa</h3>
          <p>
            Apenas o Facebook não justifica uma comunidade forte. Há muitas
            empresas como Walmart, Pinterest, Wix, Uber e diversos
            desenvolvedores no mundo todo apoiando ativamente não só o React
            Native, mas todo o ecossistema do React.
          </p>
        </div>
        <div className='column'>
          <i className='fa fa-dollar-sign' />
          <h3 className='subtitle'>Mercado de Trabalho</h3>
          <p>
            Comunidade ativa traz confiança para o mercado e movimenta a busca
            por desenvolvedores React Native no mundo todo. Tanto no Brasil,
            como no Exterior, há uma grande procura, inclusive para trabalhar
            remoto. Os salários variam entre 4k a 30k dependendo do seu nível de
            experiência.
          </p>
        </div>
      </div>
    </div>
  </section>
)

export default WhyLearnReactNative



// WEBPACK FOOTER //
// ./src/components/react-native-pro/WhyLearnReactNative.js